import { render, staticRenderFns } from "./TotpAuth.vue?vue&type=template&id=a94d7654&scoped=true"
import script from "./TotpAuth.vue?vue&type=script&setup=true&lang=ts"
export * from "./TotpAuth.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TotpAuth.vue?vue&type=style&index=0&id=a94d7654&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94d7654",
  null
  
)

export default component.exports